import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=63ff5c7c&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=63ff5c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff5c7c",
  null
  
)

export default component.exports